export interface ListSettings {
  direction: 'horizontal' | 'vertical'
  wrap: boolean
  showInterItemEdges: boolean
  spacing: number
}

export interface Shape {
  id: string
  shapeType: 'list'
  entityIds: string[]
  settings: ListSettings
  layout: boolean
}

export type ShapesAllMap = Record<string, Shape>
export type ShapesByEntityMap = Record<string, string[]>

export interface ShapesState {
  all: ShapesAllMap
  byEntity: ShapesByEntityMap
}

export const defaultListSettings: ListSettings = {
  direction: 'horizontal',
  wrap: true,
  showInterItemEdges: false,
  spacing: 0,
}

// Bounds/step for the spacing control; spacing is added directly to force.ts's base item gaps.
export const SPACING_STEP = 8
export const MIN_SPACING = -8
export const MAX_SPACING = 64
